import React, { Component } from 'react'
import { logs } from '@services/api'
import { Button, Card } from 'antd'
import UserStoryLog from '@pages/Logs/Log/UserStoryLog'
import ViewLog from '@pages/Logs/Log/ViewLog'
import PageLoading from '@components/PageLoading'

class Log extends Component<any, any> {
    constructor(props) {
        super(props)
        this.state = {
            loading: true,
            log: {},
            error: '',
            userStory: '',
            userStoryLoading: false,
            id: ''
        }
    }

    async componentDidMount() {
        try {
            const { computedMatch } = this.props
            const id = computedMatch.params.id
            const logRes = await logs.getList({ _id: id })
            const log = logRes.data.results.hits[0]._source
            this.setState({ loading: false, log, id })
        } catch (e) {
            this.setState(prevState => (prevState.error = e.response))
        }
    }

    isCrawlerError = (type, subType) =>
        type === 'ERROR' &&
        (subType === 'CRAWLER_INIT_SEND_CODE' ||
            subType === 'CRAWLER_AUTH_USER' ||
            subType === 'BALANCER_STATE' ||
            subType === 'MINE_INFO')

    getCrawlerUserStory = async () => {
        try {
            this.setState(prevState => (prevState.userStoryLoading = true))
            const { user_id, company_id } = this.state.log.attributes
            const storyRes = await logs.getList({ 'attributes.user_id': user_id, 'attributes.company_id': company_id })
            const userStory = storyRes.data.results.hits
            this.setState(prevState => {
                prevState.userStory = userStory
                prevState.userStoryLoading = false
                return prevState
            })
        } catch (e) {
            this.setState(prevState => (prevState.error = e.response))
        }
    }

    render() {
        const { log, error, userStory, loading, userStoryLoading, id } = this.state
        const { type, subType } = log
        return (
            <>
                {loading ? <PageLoading /> : error ? <div>Error: {error} </div> : <ViewLog log={log} />}
                {userStoryLoading ? (
                    <PageLoading />
                ) : this.isCrawlerError(type, subType) && !userStory ? (
                    <Card>
                        <Button onClick={this.getCrawlerUserStory}>View user story</Button>
                    </Card>
                ) : (
                    ''
                )}
                {userStory ? <UserStoryLog userStory={userStory} id={id} /> : ''}
            </>
        )
    }
}

export default Log
